var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighRiskLocalRolesCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "06ot3rcdza",
    d: "M0 0h14.803v14.295H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vlq601aq3c",
    d: "M0 0h8.43v11.44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.444 5.705)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5akx9s1zab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#06ot3rcdza"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.402 9.802 6.07 5.28h2.664L7.402 9.802zm0 2.713a.88.88 0 0 1-.628-.265.913.913 0 0 1 0-1.28.88.88 0 0 1 1.256 0 .913.913 0 0 1 0 1.28.88.88 0 0 1-.628.265zM8.186.48a.894.894 0 0 0-.47-.422.874.874 0 0 0-.627 0 .894.894 0 0 0-.471.422L.104 12.967a.918.918 0 0 0 .023.89c.16.272.45.438.76.438h13.029c.311 0 .6-.166.76-.438.16-.272.17-.61.024-.89L8.186.48z",
    fill: "#AEB3B7",
    mask: "url(#5akx9s1zab)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bq1vfxxtad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vlq601aq3c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.216 2.507c.466 0 .912.188 1.242.524.329.335.514.79.514 1.265 0 .474-.185.93-.514 1.264a1.74 1.74 0 0 1-1.242.524 1.74 1.74 0 0 1-1.242-.524 1.806 1.806 0 0 1-.515-1.264c0-.475.186-.93.515-1.265a1.74 1.74 0 0 1 1.242-.524zM.673 6.617l.02.031.08.12 3.052 4.464a.474.474 0 0 0 .782 0l3.044-4.46c.03-.043.057-.083.086-.12l.018-.029c.551-.868.776-1.91.633-2.934a4.316 4.316 0 0 0-1.41-2.638A4.17 4.17 0 0 0 4.215 0a4.17 4.17 0 0 0-2.763 1.051 4.316 4.316 0 0 0-1.41 2.638 4.357 4.357 0 0 0 .633 2.934l-.002-.006z",
    fill: "#AEB3B7",
    mask: "url(#bq1vfxxtad)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskLocalRolesCs);
export default __webpack_public_path__ + "static/media/high-risk-local-roles-cs.d776ae56.svg";
export { ForwardRef as ReactComponent };